import { useQuery } from '@tanstack/react-query';

import { QueryContextFromKeys, QueryParamModel } from 'models';
import { ucseCapacityByAreaService } from 'services/ucseCapacityByArea.service';

type UcseCapacityByAreaContexts = QueryContextFromKeys<typeof availabilityKeys>;

export const availabilityKeys = {
  all: [{ scope: 'ucseCapacityByArea' }] as const,
  lists: () => [{ ...availabilityKeys.all[0], entity: 'list' }] as const,
  list: (params?: QueryParamModel | null) => [{ ...availabilityKeys.lists()[0], params }] as const,
};

const fetchUcseCapacityByAreaList = async ({
  queryKey: [{ params }],
}: UcseCapacityByAreaContexts['list']) =>
  ucseCapacityByAreaService.getUcseCapacityByAreaList(params);

export const useUcseCapacityByAreaList = (params?: QueryParamModel | null) =>
  useQuery({
    queryKey: availabilityKeys.list(params),
    queryFn: fetchUcseCapacityByAreaList,
    enabled: !!params?.filter,
  });
